// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VeeValidate, { Validator } from 'vee-validate'
import store from './store'
import AppButton from './components/app-button'
import AppCheckbox from '@/components/app-checkbox'
import { Datetime } from '@/components/ms-datetime'
import i18n from './lang'
import veeFr from 'vee-validate/dist/locale/fr'
import veeEs from 'vee-validate/dist/locale/es'
import veeIt from 'vee-validate/dist/locale/it'
import veeDe from 'vee-validate/dist/locale/de'
import veePl from 'vee-validate/dist/locale/pl'
import veeHu from 'vee-validate/dist/locale/hu'

// Import the main Sass manifest file
import './assets/sass/main.scss'

Vue.config.productionTip = false

Vue.use(VeeValidate)

const dictionary = {
  fr: veeFr,
  es: veeEs,
  it: veeIt,
  de: veeDe,
  pl: veePl,
  hu: veeHu
}

// Load in VeeValidate locales
Validator.localize(dictionary)

Vue.component('AppButton', AppButton)
Vue.component('AppCheckbox', AppCheckbox)
Vue.component('MsDatetime', Datetime)

/* eslint-disable no-new */
new Vue({
  i18n,
  store,
  el: '#app',
  router,
  render: h => h(App)
})
